// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Ubuntu:300,400,500,700);"]);
// Module
exports.push([module.id, "body {\n  margin: 0;\n  box-sizing: border-box;\n}\n", ""]);
// Exports
module.exports = exports;
